/**
 * 基于经纬度 高度 角度对视角进行设定
 * @param {*} lon
 * @param {*} lat
 * @param {*} height
 * @param {*} angle
 */
function setCamera (lon, lat, height, angle) {
  const cameraView = ''
  return cameraView
}

// 基于范围进行view设定
function setViewByExtent (extent, heading, pitch, self) {
  self = self || this
  const viewer = self.viewer
  viewer.camera.setView({
    // west, south, east, north
    destination: Cesium.Rectangle.fromDegrees(0.0, 20.0, 10.0, 30.0),
    orientation: {
      // 方向
      heading: Cesium.Math.toRadians(20.0),
      pitch: Cesium.Math.toRadians(-90.0), // 倾斜角度
      roll: 0
    }
  })
}

function setViewByLookAt (info, self) {
  self = self || this
  const demo = {
    name: 'beijing',
    lon: 109.12760565255222,
    lat: 37.0418544952459,
    height: 2995875.9471588745,
    heading: 6.283185307179586,
    pitch: -1.5707200186394887
  }
  const lon = info.lon ? info.lon : demo.lon
  const lat = info.lat ? info.lat : demo.lat
  const heading = info.heading ? info.heading : demo.heading
  const pitch = info.pitch ? info.pitch : demo.pitch
  const height = info.height ? info.height : demo.height
  // camera视野的中心点坐标
  var center = Cesium.Cartesian3.fromDegrees(lon, lat)
  // var headingCesium = Cesium.Math.toRadians(heading)
  // var pitchCesium = Cesium.Math.toRadians(pitch)
  // 高度
  // var range = range ? range : 5000.0

  const viewer = self.viewer
  viewer.camera.lookAt(
    center,
    new Cesium.HeadingPitchRange(heading, pitch, height)
  )
  return true
}

function demoCode (viewer) {
  // 此处为官网参考
  // 1. Using a cartesian offset
  var transform = Cesium.Transforms.eastNorthUpToFixedFrame(
    Cesium.Cartesian3.fromDegrees(-98.0, 40.0)
  )
  viewer.camera.lookAtTransform(
    transform,
    new Cesium.Cartesian3(0.0, -4790000.0, 3930000.0)
  )

  // 2. Using a HeadingPitchRange offset
  var transform1 = Cesium.Transforms.eastNorthUpToFixedFrame(
    Cesium.Cartesian3.fromDegrees(-72.0, 40.0)
  )
  // 此处参数为 度数
  var heading = Cesium.Math.toRadians(50.0)
  var pitch = Cesium.Math.toRadians(-20.0)
  // range 应该和 height 相关
  var range = 5000.0
  viewer.camera.lookAtTransform(
    transform1,
    new Cesium.HeadingPitchRange(heading, pitch, range)
  )
}

function setCameraBySetView (info, self) {
  self = self || this
  const viewer = self.viewer
  const lon = info.lon
  const lat = info.lat
  const height = info.height
  const heading = info.heading
  const pitch = info.pitch
  const roll = info.roll

  viewer.camera.setView({
    destination: Cesium.Cartesian3.fromDegrees(
      lon, lat, height
    ),
    orientation: {
      heading: Cesium.Math.toRadians(heading),
      pitch: Cesium.Math.toRadians(pitch),
      roll: Cesium.Math.toRadians(roll)
    }
  })
}

function setCameraflyTo (info, self) {
  const viewer = self.viewer
  const scene = viewer.scene
  const camera = scene.camera
  const lon = info.lon
  const lat = info.lat
  const height = info.height
  const heading = info.heading || 0
  const pitch = info.pitch || 0
  const roll = info.roll || 0

  camera.flyTo({
    destination: Cesium.Cartesian3.fromDegrees(
      lon, lat, height),
    orientation: {
      heading: heading,
      pitch: pitch,
      roll: roll
    }
  })
  return true
}

export { setCamera, setViewByLookAt, setCameraBySetView, setCameraflyTo }
